import type { FunctionComponent } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import { Box, Inline, Stack, Text, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useToken } from '../../../Flow/ConsentContextProvider';
import Label from '../Label';

const messages = defineMessages({
  header: {
    id: 'oauth.rovo.permissions.header',
    defaultMessage:
      '{appName} will be able to read your data and act on your behalf in Atlassian products.',
    description: 'Header describing permissions',
  },
  permissionsHeading: {
    id: 'oauth.rovo.permissions.heading',
    defaultMessage: 'Permissions',
    description: 'Heading shown above the permissions card',
  },
});

const cardStyle = xcss({
  borderRadius: 'radius.xxlarge',
  borderWidth: 'border.width',
  borderStyle: 'solid',
  borderColor: 'color.border',
  paddingBlock: 'space.200',
  paddingInline: 'space.100',
});

const PermissionsBullets: FunctionComponent = () => {
  const { clientName } = useToken();
  return (
    <Stack space="space.050">
      <Label>
        <FormattedMessage {...messages.permissionsHeading} />
      </Label>
      <Box xcss={cardStyle}>
        <Inline space="space.100" alignBlock="start">
          <Box paddingInline="space.050">
            <CheckCircleIcon
              label=""
              size="medium"
              color={token('color.text')}
            />
          </Box>
          <Text as="p">
            <FormattedMessage
              {...messages.header}
              values={{
                appName: <strong>{clientName}</strong>,
              }}
            />
          </Text>
        </Inline>
      </Box>
    </Stack>
  );
};

export default PermissionsBullets;
